export const propsToDisplay = {
  // fixed price
  fixedProfit: {
    breakEven: 'breakEven',
    profit: 'profit',
    fixedFee: 'fixedFee'
  },
  // competition
  competition: {
    breakEven: 'breakEven',
    minimalProfit: 'minimalProfit',
    optimalProfit: 'optimalProfit',
    // optimalProfitPercent: 'optimalProfit',
  },
  // penetration
  penetration: {
    breakEven: 'breakEven',
    minimalProfit: 'minimalProfit',
    maximalProfit: 'maximalProfit',
    upTimes: 'upTimes',
    up: 'up',
    downDays: 'downDays',
    down: 'down',
  },
};
